<template>
    <div
        :class="
            'flex h-10 w-14 items-center justify-center whitespace-nowrap rounded rounded-full px-4 font-semibold' +
            ' ' +
            scoreColor
        "
    >
        {{ Math.round(score * 100) }}%
    </div>
</template>
<script>
export default {
    name: "focus-area-score-round-label",
    props: {
        score: { type: Number, default: null },
    },
    computed: {
        scoreColor() {
            if (this.score < 0.7) {
                return "bg-red-50 text-red-600";
            }

            if (this.score < 0.85) {
                return "bg-yellow-100 text-yellow-600";
            }

            return "bg-green-100 text-green-600";
        },
    },
};
</script>
